// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.convert.RentalManagerUserPropertyConvertV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily,
  RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyConvertMultiToSingleFamilyRequestDto,
  UserPropertyConvertMultiToSingleFamilyV2ResponseWebDto,
  UserPropertyConvertSingleFamilyToRoomForRentRequestDto,
  UserPropertyConvertSingleFamilyToRoomForRentV2ResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Args {
  postData: UserPropertyConvertMultiToSingleFamilyRequestDto;
}

export type RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Options = UseMutationOptions<
  UserPropertyConvertMultiToSingleFamilyV2ResponseWebDto,
  unknown,
  RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Args
>;

/**
 * Convert a multifamily property to a single family property
 */
export const useRentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily_Args) =>
      RentalManagerUserPropertyConvertV2WebApiHandler_multiToSingleFamily(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Args {
  postData: UserPropertyConvertSingleFamilyToRoomForRentRequestDto;
}

export type RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Options = UseMutationOptions<
  UserPropertyConvertSingleFamilyToRoomForRentV2ResponseWebDto,
  unknown,
  RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Args
>;

/**
 * Convert a single family property to a room for rent property
 */
export const useRentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent_Args) =>
      RentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent(args.postData, httpClient),
  });
};
